<!--
/**
 * peacohrm is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 peacohrm Inc., http://www.peacohrm.com
 *
 * peacohrm is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * peacohrm is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */
 -->

<template>
  <acquisition-status v-if="candidate" :candidate="candidate">
  </acquisition-status>
  <candidate-profile
    v-if="candidate"
    :candidate="candidate"
    :allowed-file-types="allowedFileTypes"
    :max-file-size="maxFileSize"
    :updatable="updatable"
    @update="onCandidateUpdate"
  ></candidate-profile>
  <history-table v-if="candidate" :candidate="candidate"></history-table>
</template>

<script>
import {APIService} from '@/core/util/services/api.service';
import RecruitmentStatus from '@/peacohrmRecruitmentPlugin/components/RecruitmentStatus';
import CandidateProfile from '@/peacohrmRecruitmentPlugin/components/CandidateProfile';
import HistoryTable from '@/peacohrmRecruitmentPlugin/components/HistoryTable';

export default {
  components: {
    'history-table': HistoryTable,
    'candidate-profile': CandidateProfile,
    'acquisition-status': RecruitmentStatus,
  },
  props: {
    candidateId: {
      type: Number,
      required: true,
    },
    maxFileSize: {
      type: Number,
      required: true,
    },
    allowedFileTypes: {
      type: Array,
      required: true,
    },
    updatable: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup() {
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/acquisition/candidates',
    );
    return {
      http,
    };
  },
  data() {
    return {
      candidate: null,
    };
  },
  beforeMount() {
    this.onCandidateUpdate();
  },
  methods: {
    onCandidateUpdate() {
      this.http.get(this.candidateId).then(({data: {data}}) => {
        this.candidate = data;
      });
    },
  },
};
</script>
